'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interceptClick = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
/*:: import type {ComponentType} from 'react' */


var interceptor = function interceptor(interceptFn) {
  return function (event) {
    event.stopPropagation();
    event.preventDefault();
    interceptFn(event);
  };
};

var interceptClick = function interceptClick(Component /*: ComponentType<*> */) {
  return function (_ref /*: {intercept: SyntheticEvent<> => any, children: React.Node} */) {
    var intercept = _ref.intercept,
        children = _ref.children,
        props = _objectWithoutProperties(_ref, ['intercept', 'children']);

    return React.createElement(
      Component,
      Object.assign({}, props, { onClickCapture: interceptor(intercept) }),
      children
    );
  };
};
exports.interceptClick = interceptClick;


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/interceptClick.js
// module id = 630
// module chunks = 0